import React from 'react'

export default function BusWidget({ bus, above, avgHeadway, isSelected, onSelect }) {
  // Determine status colour and muted background
  let statusColor = 'var(--text-muted)'
  let mutedBg = 'var(--bg-surface)'   // default neutral (never transparent)
  if (bus.headway != null && avgHeadway != null && avgHeadway > 0) {
    const diff = bus.headway - avgHeadway
    const tolerance = 30 // 0.5 minute in seconds
    if (Math.abs(diff) <= tolerance) {
      statusColor = 'var(--status-amber)'
      mutedBg = 'var(--amber-muted)'
    } else if (diff < 0) {
      statusColor = 'var(--live-red)'        // red
      mutedBg = 'var(--live-red-muted)'
    } else {
      statusColor = 'var(--live-green)'      // green
      mutedBg = 'var(--live-green-muted)'
    }
  }

  const headwayDisplay = bus.headway !== null && bus.headway !== undefined
    ? (bus.headway / 60).toFixed(1)
    : '-'

  // Arrow always uses the status colour (never changes)
  const arrowLeft = {
    width: 0,
    height: 0,
    borderTop: '7px solid transparent',
    borderBottom: '7px solid transparent',
    borderRight: `10px solid ${statusColor}`,
    flexShrink: 0,
    transition: 'border-color 0.15s ease',
  }
  const arrowRight = {
    width: 0,
    height: 0,
    borderTop: '7px solid transparent',
    borderBottom: '7px solid transparent',
    borderLeft: `10px solid ${statusColor}`,
    flexShrink: 0,
    transition: 'border-color 0.15s ease',
  }

  // Selected: thick border in status colour, background stays the same
  const selectedZIndex = isSelected ? 100 : 10
  const selectedBorder = isSelected ? `3px solid ${statusColor}` : '1.5px solid var(--border)'
  // const selectedShadow = isSelected ? `0 0 0 2px ${statusColor}40` : 'var(--shadow-md)'
  const selectedShadow = isSelected ? 'var(--selected-shadow)' : 'var(--shadow-md)';
  // Background never changes on selection
  const bgColor = mutedBg

  return (
    <div
      onClick={onSelect}
      style={{
        position: 'relative',
        width: 'max-content',
        zIndex: selectedZIndex,
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'z-index 0.1s',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {above && <div style={arrowLeft} />}

        <div style={{
          background: bgColor,                     // always muted/neutral
          border: selectedBorder,
          borderRadius: 9,
          padding: '6px 9px 5px',
          boxShadow: selectedShadow,
          minWidth: 96,
          transform: 'scale(1)',
          transition: 'all 0.18s cubic-bezier(0.34, 1.56, 0.64, 1)',
          overflow: 'hidden',
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 6 }}>
            <span style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 12,
              fontWeight: 700,
              color: 'var(--text-primary)',       // unchanged
              background: 'var(--bg-muted)',
              padding: '1px 6px',
              borderRadius: 5,
              lineHeight: 1.6,
            }}>{bus.bonnet_no}</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
              <span style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 10,
                fontWeight: 600,
                color: 'var(--text-primary)',   // unchanged
                lineHeight: 1,
              }}>Trip {bus.trip_no_lbsl}</span>
              <span style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 10,
                fontWeight: 600,
                color: 'var(--text-primary)',   // unchanged
                lineHeight: 1,
              }}>Run {bus.running_no}</span>
            </div>
          </div>

          {/* Headway row – hidden text */}
          <div style={{
            marginTop: 5,
            fontSize: 10,
            color: 'transparent',
            background: 'transparent',
            fontFamily: 'var(--font-mono)',
            textAlign: 'center',
            borderTop: `1px solid ${isSelected ? 'var(--text-on-overlay-muted)' : 'var(--border-subtle)'}`,
            paddingTop: 4,
            paddingBottom: 2,
            borderRadius: '0 0 4px 4px',
          }}>
            {headwayDisplay} min hdwy
          </div>
        </div>

        {!above && <div style={arrowRight} />}
      </div>

      {/* Vertical stem – colour matches status when selected */}
      <div style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 1.5,
        height: 14,
        background: isSelected ? statusColor : 'var(--border)',
        top: above ? 'calc(100% + 4px)' : 'auto',
        bottom: above ? 'auto' : 'calc(100% + 4px)',
        pointerEvents: 'none',
        transition: 'background 0.15s',
      }} />
    </div>
  )
}